import { cn } from '../../lib/cn.js'
import {
  launcherButtonAnimationClass,
  resolveLauncherButtonIcon,
} from '@shared/launcherButtonIcons.jsx'

export { launcherButtonAnimationClass } from '@shared/launcherButtonIcons.jsx'

export function LauncherButtonIcon({ name, animation, className }) {
  const key = String(name || '').trim()
  if (!key) return null
  const Icon = resolveLauncherButtonIcon(key)
  if (!Icon) return null

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center',
        launcherButtonAnimationClass(animation),
        className,
      )}
      aria-hidden
    >
      <Icon className="h-4 w-4" />
    </span>
  )
}

/**
 * Label row for AI Display button triggers (text + optional icon position/animation).
 */
export function LauncherButtonContent({ conf, textClassName }) {
  const text =
    conf?.buttonText?.trim?.() || conf?.widgetTitle || 'Chat with AI'
  const iconKey = String(conf?.buttonIcon || '').trim()
  const position = String(conf?.buttonIconPosition || 'before')
    .trim()
    .toLowerCase()
  const animation = conf?.buttonIconAnimation
  const iconEl = iconKey ? (
    <LauncherButtonIcon name={iconKey} animation={animation} />
  ) : null

  return (
    <>
      {position !== 'after' && iconEl}
      <span className={textClassName}>{text}</span>
      {position === 'after' && iconEl}
    </>
  )
}
